import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

const DialogContentStyle = ({ theme }) => ({
  width: '100%',
  overflowX: 'hidden',
  paddingTop: 40,
  [theme.breakpoints.up('md')]: {
    paddingTop: 64
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
